"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Image = _interopRequireDefault(require("../Image"));

require("./userAvatar.css");

var smallest = 'avatar-smallest';
var small = 'avatar-small';
var medium = 'avatar-medium';
var large = 'avatar-large';
/** Displays either an image of a user or their initials. */

var UserAvatar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UserAvatar, _React$Component);

  function UserAvatar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UserAvatar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UserAvatar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getUserInitials", function () {
      return _react.default.createElement("div", {
        className: "user-initials",
        title: _this.props.displayName
      }, _this.props.userInitials);
    });
    return _this;
  }

  (0, _createClass2.default)(UserAvatar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isLoading = _this$props.isLoading,
          avatarUri = _this$props.avatarUri,
          alt = _this$props.alt;
      return _react.default.createElement("div", {
        className: "user-avatar"
      }, _react.default.createElement(_Image.default, {
        entityType: "user",
        imageUri: avatarUri,
        isLoading: isLoading,
        alt: alt,
        imageSizeClassName: this.normalizeSizeClassName(),
        getHasNoImage: this.getUserInitials
      }));
    }
  }, {
    key: "normalizeSizeClassName",
    value: function normalizeSizeClassName() {
      switch (this.props.avatarSizeClass) {
        case 'smallest':
        case smallest:
          return smallest;

        case 'small':
        case small:
          return small;

        case 'large':
        case large:
          return large;

        case 'medium':
        case medium:
        default:
          return medium;
      }
    }
  }]);
  return UserAvatar;
}(_react.default.Component);

exports.default = UserAvatar;
(0, _defineProperty2.default)(UserAvatar, "smallest", smallest);
(0, _defineProperty2.default)(UserAvatar, "small", small);
(0, _defineProperty2.default)(UserAvatar, "medium", medium);
(0, _defineProperty2.default)(UserAvatar, "large", large);
UserAvatar.propTypes = {
  /** The user's full display name */
  displayName: _propTypes.default.string,

  /** "avatar-" small, medium, large or smallest */
  avatarSizeClass: _propTypes.default.string,

  /** URI path to user's avatar image */
  avatarUri: _propTypes.default.string,

  /** Initials to display if the user has no valid image */
  userInitials: _propTypes.default.string,

  /** Loading state for the avatar */
  isLoading: _propTypes.default.bool,

  /** alt property for the underlying image */
  alt: _propTypes.default.string
};
UserAvatar.defaultProps = {
  avatarSizeClass: 'avatar-medium',
  isLoading: false,
  alt: 'User Avatar'
};